'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postStartTrackExitIntent = undefined;

var _createPostMessageAction = require('../../post-message/actions/createPostMessageAction');

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var postStartTrackExitIntent = exports.postStartTrackExitIntent = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.START_TRACK_EXIT_INTENT);